export default class Selectable {
    constructor(options) {
        this.collection_bar = options.collection_bar;
        this.swatches = options.swatches;

        this.dom = {
            el: options.el
        };

        this.data = {
            id: this.dom.el.getAttribute("data-product-id"),
            sku: this.dom.el.getAttribute("data-product-sku")
                ? this.dom.el.getAttribute("data-product-sku")
                : 0,
            quantity: 1
        };

        this.events();
    }

    events() {
        let json = JSON.stringify(this.data);

        this.dom.el.addEventListener("click", () => {
            if (this.dom.el.classList.contains("selected")) {
                this.unselect(json);
            } else {
                this.select(json);
            }
        });
    }

    select(json) {
        this.dom.el.classList.add("selected");
        this.collection_bar.open();
        window.stagedProducts.add(json);
        this.swatches._toggle_noswatches();
    }

    unselect(json) {
        this.dom.el.classList.remove("selected");
        window.stagedProducts.delete(json);
        this.collection_bar.close();
    }
}
